<div>
  <div class="modal-header">
    <div style="display: flex;">
      <h5 style="margin: 5px;">{{mostRecentExecuted.mobileEndPoint ? 'Mobile' : 'Desktop'}} Configuration</h5>
    </div>
    <button type="button" class="close" aria-label="Close" (click)="cancelModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" id="modal-body">
    <table class="table table-bordered table-sm">
      <thead class="mobile-configuration-table-header">
        <tr>
          <th style="width: 50%;">Key</th>
          <th style="width: 50%;">Value</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of mobileEnvironmentArray; let i = index">
          <td>{{data.key}}</td>
          <td>
            <div *ngIf="data.key === 'SauceLabUrl'"> <a href="{{data.value}}" target="_blank">{{data.value}}</a></div>
            <div *ngIf="data.key !== 'SauceLabUrl'">{{data.value}}</div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="modal-footer confirm-footer">
    <button class="btn btn-warning btn-sm" type="button" (click)="cancelModal()">Close</button>
  </div>
</div>